<template>
  <el-container class="desc-body">
    <div class="desc-header">
      <h2>比赛说明</h2>
    </div>
    <div class="competition-type" v-html="competitionObj.summary">
      
    </div>
    <div class="competition-materials">
      <p v-for="(item,index) in competitionObj.materials" :key="index">
        <span>
          <i class="el-icon-paperclip"></i>附件
        </span>
        <span style="color:blue;">{{item.name}}</span>
        <span>
          <a :download="item.name" :href="item.url" target="_blank">下载</a>
        </span>
      </p>
    </div>
  </el-container>
</template>
<script>
import {} from "@/api/contest";
export default {
  data() {
    return {
      
    };
  },
  props:['competitionObj'],
  mounted() {
    
  }
};
</script>
<style scoped>
.desc-body {
  width: 1000px;
  border: 1px solid #dce1e6;
  margin: auto;
  padding: 20px;
  display: block;
}
.desc-body .desc-header {
  height: 30px;
  width: 100%;
  margin: 10px 0;
  line-height: 30px;
  border-bottom: 1px solid #dce1e6;
}
.competition-type,
.competition-award {
  margin: 15px 0;
}
.p-title {
  color: #46a1ff;
  margin: 5px 0;
}
.competition-type img,
.competition-award img {
  max-width: 100%;
}

.competition-materials p .el-icon-paperclip {
  color: #46a1ff;
  font-size: 18px;
}
.competition-materials p span {
  margin-right: 15px;
}
</style>